;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	type CreateDataProviderSchema,
	createDataProviderSchema,
	type DeleteDataProviderSchema,
	deleteDataProviderSchema,
	type EditDataProviderSchema,
	editDataProviderSchema,
	type PingDataProviderSchema,
	pingDataProviderSchema,
} from "@/lib/schema/data-provider";

import { logger } from "@/lib/services/logger";
import { queryFetcher } from "@/queries/config/query-fetcher";

export async function deleteDataProvider(
	data: DeleteDataProviderSchema,
): Promise<{ message: string }> {
	// Lets validate the data
	const validationResult = deleteDataProviderSchema.safeParse(data);

	if (!validationResult.success) {
		logger.error("Error deleting data provider", validationResult.error, {
			feature: "data-providers",
		});

		throw new Error("Error deleting this data provider");
	}

	const { workspaceId, providerId } = validationResult.data;

	return queryFetcher(
		`/api/workspaces/${workspaceId}/data-provider/${providerId}`,
		{
			method: "DELETE",
		},
	);
}

export async function editDataProvider(
	data: EditDataProviderSchema,
): Promise<{ message: string }> {
	const validationResult = editDataProviderSchema.safeParse(data);

	if (!validationResult.success) {
		logger.error("Error editing data provider", validationResult.error, {
			feature: "data-providers",
		});

		throw new Error("Error editing this data provider");
	}

	const { workspaceId, provider, data: payload } = validationResult.data;

	return queryFetcher(
		`/api/workspaces/${workspaceId}/data-provider/${provider.id}`,
		{
			body: JSON.stringify({ ...payload, type: provider.type }),
			method: "PUT",
		},
	);
}

export async function createDataProvider(
	data: CreateDataProviderSchema,
): Promise<{ message: string }> {
	// Lets validate the data
	const validationResult = createDataProviderSchema.safeParse(data);

	if (!validationResult.success) {
		logger.error("Error creating data provider", validationResult.error, {
			feature: "data-providers",
		});

		throw new Error("Error creating this data provider");
	}

	const { workspaceId, data: payload } = validationResult.data;

	return queryFetcher(`/api/workspaces/${workspaceId}/data-provider`, {
		body: JSON.stringify(payload),
		method: "POST",
	});
}

export async function pingDataProvider(data: PingDataProviderSchema): Promise<{
	accountId?: string;
	isCredentialsValid: boolean;
	projects?: { id: string; name: string }[];
	vendors?: Array<Record<string, unknown>>;
	workspaces?: { id: string; name: string }[];
}> {
	// Lets validate the data
	const validationResult = pingDataProviderSchema.safeParse(data);

	if (!validationResult.success) {
		logger.error(
			"[PING]: Invalid data provider credentials",
			validationResult.error,
			{
				feature: "data-providers",
			},
		);

		throw new Error("Invalid data provider credentials");
	}

	const { workspaceId, data: payload } = validationResult.data;

	return queryFetcher(`/api/workspaces/${workspaceId}/data-provider/ping`, {
		body: JSON.stringify(payload),
		method: "POST",
	});
}

export async function retryPodiumWebhookInstallation(data: {
	workspaceId: string;
}): Promise<{ message: string }> {
	return queryFetcher(
		`/api/workspaces/${data.workspaceId}/data-provider/podium`,
		{
			body: JSON.stringify({
				retry: true,
			}),
			method: "POST",
		},
	);
}
